<app-form-page [content]="content" />

<ng-template #content>
  <div class="m-t-2 m-b-3 text-align-center">
    <svg-icon
      role="img"
      src="assets/images/aptem-assess-logo-content.svg"
      data-ua-id="landing-page-logo"
    >
    </svg-icon>
  </div>

  <h2 class="text-bold m-b-3 text-align-center">
      <span>Almost there...</span>
  </h2>
    <p>
      We have sent you an email to verify your email address. Please check your junk/spam folder if the email does not arrive.

    </p>

    <p class="m-b-5">
      If you have any issues please contact: <a href="mailto:support@aptemassess.co.uk">support&commat;aptemassess.co.uk</a>
    </p>
  <div>
    <svg-icon
      src="assets/images/verify-email.svg"
      [svgStyle]="{ 'width.px': 325, 'height.px': 223 }"
    >
    </svg-icon>
  </div>
</ng-template>
